
import { Component, computed, inject, Signal } from '@angular/core';
import { BadgeComponent, Status } from '@webapp/ui';
import { getBadgeAndActions } from '../../../common/map';
import { IQuoteDetail } from '../../../interfaces/quotes.interface';
import { QuotesStoreService } from '../../../store/quotes-store.service';
import { QuoteCoverageCardComponent } from '../quote-coverage-card/quote-coverage-card.component';
import { QuoteInfoComponent } from '../quote-info/quote-info.component';
import { UserResumeComponent } from '@webapp/core/ui/components/user-resume/user-resume.component';
import { DisclaimerComponent } from '@webapp/core/ui/components/disclaimer/disclaimer.component';

@Component({
  selector: 'app-quotes-detail',
  standalone: true,
  imports: [
    BadgeComponent,
    QuoteInfoComponent,
    UserResumeComponent,
    QuoteCoverageCardComponent,
    DisclaimerComponent
],
  templateUrl: './quotes-detail.component.html',
  styleUrl: './quotes-detail.component.scss',
})
export class QuotesDetailComponent {
  Status = Status;
  quotesStore = inject(QuotesStoreService);

  get quote(): Signal<IQuoteDetail | null> {
    return computed(() => {
      const quote = this.quotesStore.get()();
      if (!quote) {
        return null;
      }
      return { ...quote, ...getBadgeAndActions(quote) };
    });
  }

  coverages() {
    if (!this.quote()) {
      return [];
    }
    const quote = this.quote() ?? {} as IQuoteDetail;
    return [...quote.coverages];
  }
}
